import styles from "@/styles/Header.module.scss";
import ActiveLink from "@/components/ActiveLink";
import ScrollMenu from "@/components/ScrollMenu";
import { useAuthUserQuery } from "@/hooks";
import routes from "@/lib/routes";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function AuthorizedPrimaryNavigationForSp(_ref) {
  let {
    loggedIn
  } = _ref;
  if (!loggedIn) return null;
  return /*#__PURE__*/_jsx("div", {
    className: styles.primaryNavigationForSp,
    children: /*#__PURE__*/_jsxs(ScrollMenu, {
      className: styles.primaryNavigationForSpInner,
      children: [/*#__PURE__*/_jsx("div", {
        className: `${styles.slideItem} ${styles.homeLink}`,
        children: /*#__PURE__*/_jsx(ActiveLink, {
          href: routes.home,
          children: /*#__PURE__*/_jsx("a", {
            className: styles.slideItemLink,
            children: /*#__PURE__*/_jsx("span", {
              children: "\u30DB\u30FC\u30E0"
            })
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles.slideItem,
        children: /*#__PURE__*/_jsx(ActiveLink, {
          href: routes.valuePlan,
          matchtype: "partial",
          children: /*#__PURE__*/_jsx("a", {
            className: styles.menuContLink,
            children: /*#__PURE__*/_jsx("span", {
              children: "\u30D0\u30EA\u30E5\u30FC\u30D7\u30E9\u30F3"
            })
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles.slideItem,
        children: /*#__PURE__*/_jsx(ActiveLink, {
          href: routes.channels,
          matchtype: "partial",
          children: /*#__PURE__*/_jsx("a", {
            className: styles.slideItemLink,
            children: /*#__PURE__*/_jsx("span", {
              children: "\u6708\u984D\u5546\u54C1"
            })
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles.slideItem,
        children: /*#__PURE__*/_jsx(ActiveLink, {
          href: routes.store,
          matchtype: "partial",
          children: /*#__PURE__*/_jsx("a", {
            className: styles.slideItemLink,
            children: /*#__PURE__*/_jsx("span", {
              children: "\u5358\u54C1\u5546\u54C1"
            })
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles.slideItem,
        children: /*#__PURE__*/_jsx(ActiveLink, {
          href: routes.myList,
          matchtype: "partial",
          children: /*#__PURE__*/_jsx("a", {
            className: styles.slideItemLink,
            children: /*#__PURE__*/_jsx("span", {
              children: "\u30DE\u30A4\u30EA\u30B9\u30C8"
            })
          })
        })
      })]
    })
  });
}
function NotAuthorizedPrimaryNavigationForSp(_ref2) {
  let {
    loggedIn
  } = _ref2;
  if (loggedIn) return null;
  return /*#__PURE__*/_jsx("div", {
    className: styles.primaryNavigationForSp,
    children: /*#__PURE__*/_jsxs(ScrollMenu, {
      className: styles.primaryNavigationForSpInner,
      children: [/*#__PURE__*/_jsx("div", {
        className: `${styles.slideItem} ${styles.homeLink}`,
        children: /*#__PURE__*/_jsx(ActiveLink, {
          href: routes.home,
          children: /*#__PURE__*/_jsx("a", {
            className: styles.slideItemLink,
            children: /*#__PURE__*/_jsx("span", {
              children: "\u30DB\u30FC\u30E0"
            })
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles.slideItem,
        children: /*#__PURE__*/_jsx(ActiveLink, {
          href: routes.valuePlan,
          matchtype: "partial",
          children: /*#__PURE__*/_jsx("a", {
            className: `${styles.menuContLink} ${styles.valuePlanLink}`,
            children: /*#__PURE__*/_jsx("span", {
              children: "\u30D0\u30EA\u30E5\u30FC\u30D7\u30E9\u30F3"
            })
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles.slideItem,
        children: /*#__PURE__*/_jsx(ActiveLink, {
          href: routes.channels,
          matchtype: "partial",
          children: /*#__PURE__*/_jsx("a", {
            className: styles.slideItemLink,
            children: /*#__PURE__*/_jsx("span", {
              children: "\u6708\u984D\u5546\u54C1"
            })
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles.slideItem,
        children: /*#__PURE__*/_jsx(ActiveLink, {
          href: routes.store,
          matchtype: "partial",
          children: /*#__PURE__*/_jsx("a", {
            className: styles.slideItemLink,
            children: /*#__PURE__*/_jsx("span", {
              children: "\u5358\u54C1\u5546\u54C1"
            })
          })
        })
      })]
    })
  });
}
// export default memo(PrimaryNavigation);
export default function PrimaryNavigationForSp() {
  const {
    loading,
    data
  } = useAuthUserQuery({
    fetchPolicy: "cache-first"
  });
  const loggedIn = !loading && (data === null || data === void 0 ? void 0 : data.user);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(NotAuthorizedPrimaryNavigationForSp, {
      loggedIn: loggedIn
    }), /*#__PURE__*/_jsx(AuthorizedPrimaryNavigationForSp, {
      loggedIn: loggedIn
    })]
  });
}